import type { SxProps, Theme } from '@mui/material/styles';

import { HEADER_HEIGHT } from '@/core/constants/layout';

export const quickSearchStyles = {
	searchRoot: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		maxWidth: '663px',
		width: '100%',
		height: '56px',
		bgcolor: 'background.paper',
		border: '1px solid',
		borderColor: 'divider',
		borderRadius: '4px',
		padding: '4px 8px',

		'&:hover': {
			border: '1px solid #1212124D'
		},
		'&:focus-within': {
			border: '1px solid var(--mui-palette-primary-main)'
		},
		'& .MuiInputBase-input': {
			padding: 0
		}
	},
	searchInput: {
		ml: 1,
		flex: 1,

		'& .MuiInputBase-input': {
			'::placeholder': {
				color: 'text.secondary',
				opacity: 1
			},
			color: 'text.fadedPrimary'
		}
	},
	searchIcon: {
		width: '20px',
		height: '20px',
		color: 'text.secondary',
		mr: 1
	},
	loadingIcon: {
		mr: 0.5,
		width: 36,
		height: 36
	},
	clearIcon: {
		mr: 0.5
	},
	popper: {
		minWidth: {
			xs: 'calc(100% - (2 * var(--mui-spacing)))',
			sm: 'unset'
		},
		overflow: 'hidden',
		borderRadius: 1,
		backgroundColor: 'background.paper',
		boxShadow:
			'0px 2px 1px -1px #00000033, 0px 1px 1px 0px #00000024, 0px 1px 3px 0px #0000001F'
	},
	dropdown: {
		padding: 0,
		paddingBottom: 1,
		margin: 0,
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',
		borderRadius: 1,
		overflow: 'hidden',
		width: '100%',
		maxHeight: `calc(80vh - ${HEADER_HEIGHT}px)`,
		minHeight: 75,
		overflowY: 'auto'
	} as SxProps<Theme>,
	linearProgress: {
		position: 'absolute',
		top: 0,
		left: 0,
		height: 2,
		width: '100%',
		zIndex: 2
	}
};
